import React from 'react';
import { Link } from 'react-router-dom';
import {useStyles} from './style';
import FormTemplate from './FormElements/index';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { Redirect } from 'react-router-dom';
import IconElement from 'components/IconElement/index'; 
import AlertDialog from './FormElements/Dialog/index'
import Footer from '../../Home/Footer2';
 const  Login= (props)=> {
    const classes = useStyles(props);

    if (props.authenticated)
        return <Redirect
                    to={{
                        pathname: "/",
                        state: { from: props.location, authenticated:props.authenticated }
                    }}/>; 
    else
        return (
            <div className={classes.loginContainer}>
               {/* <AlertDialog/> */}
                <div className={classes.title}>Portal Web GEO TSE</div>
                <div className={classes.loginBox}>
                    <div className={classes.img}>
                        <IconElement/>
                    </div>
                    <h1 className={classes.titleLeft}> Bienvenido! </h1>
                    <FormTemplate/>
                    {/*<span>NO tienes una cuenta?<Link to="/signup">vamos a crearla!</Link></span>*/}
                </div>                
                <Footer/>
            </div> 
        ) 
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);